import { useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

export default function NotFound() {
  const location = useLocation();
  const navigate = useNavigate();
  
  useEffect(() => {
    const timer = setTimeout(() => {
      navigate('/');
    }, 5000);
    return () => clearTimeout(timer);
  }, [navigate]);
  
  return (
    <div className="min-h-screen bg-background-50 flex flex-col">
      <Navbar />
      <div className="flex-1 flex items-center justify-center px-4">
        <div className="text-center max-w-lg">
          <div className="w-20 h-20 rounded-2xl bg-primary-50 flex items-center justify-center mx-auto mb-6">
            <i className="ri-error-warning-line text-3xl text-primary-600"></i>
          </div>
          <h1 className="font-heading text-6xl md:text-8xl font-bold text-foreground-200 mb-4">
            404
          </h1>
          <h2 className="font-heading text-xl md:text-2xl font-semibold text-foreground-900 mb-3">
            Page Not Found
          </h2>
          <p className="text-foreground-500 mb-2">
            The page you are looking for does not exist or has been moved.
          </p>
          <p className="text-sm text-foreground-400 font-mono mb-6">
            {location.pathname}
          </p>
          <p className="text-sm text-foreground-400 mb-8">
            Redirecting to homepage in 5 seconds...
          </p>
          <a
            href="/"
            className="btn-primary inline-flex"
          >
            <i className="ri-home-line mr-2"></i>
            Back to Home
          </a>
        </div>
      </div>
      <Footer />
    </div>
  );
}